export const locale = {
    lang: 'zh2',
    data: {
      'CIERRE': {
        'LABEL1':	'进行中的调研',
        'LABEL2':	'查看进度',
        'LABEL3':	'已完成的调研',
        'LABEL4':	'查看结果',
        'BTN_CIERRE':	'关闭',
        'ALERT':{
          'MESSAGE': '您确认要执行预期的调查吗？',
          'BTN_CONFIRM': '是',
          'BTN_CANCEL': '没有'
        },
        'LINK': '转到下一个链接以查看调查的当前进度',
        'ACTIONS':{
          'TITULO': '行动',
          'WANNADO': '你想让我做什么？'
        },
        'COMPLETO':{
          'TAG': '调查成功完成',
          'CARDTIT': '结果查询',
          'LINK': '转到下一个链接以查看调查中获得的结果'
        }
      },


      'CERTIFICAR': {
        'IDIOMAS': {
          'ELEGIR':	'选择',
          'STATUS': {
            'PEND':	'完成此步骤',
            'DONE':	'此步骤已完成'
          },
          'MENSAJES':{
            'ADDLANG':	'你选择',
            'NOADITIONAL':	'您选择不设置其他语言',
            'ERRORADD':	'选择语言时发生错误',
            'LANGDEL':	'您删除了',
            'NOADITIONALDEL':	'您取消了不设置其他语言的选项',
            'ERRORDEL':	'删除语言时发生错误',
            'MAINPICKED':	'您已选择调研的主要语言。<br> <br>若要更改，请删除所选的语言并选择另一个语言选项。'
          },
          'CARD1': {
            // 'TITULO': 'Idioma principal',
            'ACCION': {
              // 'PRE': 'No ha seleccionado el idioma principal',
              // 'POST': 'Ha seleccionado el idioma:'
            },
            'MODAL': {
              'TITULO':	'选择主要语言',
              'ACCION':	'调查的主要使用哪种语言？',
              'PLACELISTA':	'选择语言',
              'BOTONES': {
                'BACK':	'回上页',
                'OK':	'完成'
              }
            }
          },
          'CARD2': {
            'TITULO':	'其他语言',
            'ACCION': {
              'PRE':	'您尚未选择其他语言',
              'SINADIC':	'调研将不会有其他语言',
              'POST':	'您选择了以下语言'
            },
            'MODAL': {
              'TITULO':	'选择其他语言',
              'ACCION':	'您想添加哪些语言？',
              'BOTONES': {
                'BACK':	'回上页',
                'OK':	'完成'
              }
            }
          }
        },
        'DEMOGRAFICOS': {
          // 'TAB1': 'Demograficos',
          // 'TAB2': 'Traducción',
          // 'TAB3': 'Previsualización',
          // 'COMPLETAR_PASO': 'Completar paso',
          // 'PASO_COMPLETADO': 'Paso completado',
          // 'SELECT': 'Seleccione una opción',
          // 'BTN_DEMOGRAFICOS': 'Aceptar',
          // 'OPTION_SURVEY': 'Encuesta',
          // 'OPTION_EXCEL': 'Excel',
          // 'CONFIGURE_QUESTION': 'Click aquí para configurar la pregunta',
          // 'QUESTION': 'Pregunta',
          // 'OPCIONES_RESPUESTA': 'Opciones de respuesta',
          'STATUS': {
            // 'PEND': 'Completar paso',
            // 'DONE': 'Paso completado'
          }
        },
        'FORALL': {
          'SELECCIONE':	'选择一种语言',
          'IDIOMAS_NOT_SELECTED':	'未选择翻译其他语言',
          'PLACEHOLDER':	'语言',
          'DESC_TRANSLATE':	'输入描述',
          'PRACTICE_TRANSLATE':	'输入实践',
          'IDIOMAS': {
              // 'Native': 'Nativo',
              // 'es': 'Español',
              // 'zh1': 'Chino Tradicional',
              // 'zh2': 'Chino Simplificado',
              // 'pt': 'Portugués',
              // 'en': 'Inglés'
            },
          'RESPUESTAS': {
              // 'Native': 'Nativo',
              'es':{'si': 'SÍ',
                    'no':'NO',
                    'casifalso':'Casi siempre es falso',
                    'false': 'Frecuentemente es falso',
                    'avecesfalse': 'A veces es falso / A veces es verdad',
                    'casiverdad': 'Frecuentemente es verdad',
                    'verdad': 'Casi siempre es verdad'},
              'zh1':{'si': '对','no':'没有',
                    'casifalso':'卡西尔·辛普森·法斯特',
                    'false': '基金会',
                    'avecesfalse': '途径/途径',
                    'casiverdad': '纪念馆',
                    'verdad': '普通绿卡'},
              'zh2':{'si': '对','no':'没有',
                    'casifalso':'卡西尔·辛普森·法斯特',
                    'false': '基金会',
                    'avecesfalse': '途径/途径',
                    'casiverdad': '纪念馆',
                    'verdad': '普通绿卡'},
              'pt':{'si': 'SI','no':'não',
                    'casifalso':'Casi siempre es falso',
                    'false': 'Freqüentemente é falso',
                    'avecesfalse': 'A veces es falso / A veces es verdad',
                    'casiverdad': 'Freqüentemente es verdad',
                    'verdad': 'Casi siempre es verdad'},
              'en':{'si': 'YES','no':'NO',
                    'casifalso':'It is almost always false',
                    'false': 'It is often false',
                    'avecesfalse': 'Sometimes it´s fake / Sometimes it´s true',
                    'casiverdad': 'It is often true',
                    'verdad': 'It is almost always true'}
            },
          'STATUS': {
            'PEND':	'完成步骤',
            'DONE':	'此步骤已完成',
          },
          'TABLA': {
            'TITULOS': {
              'DEFAULT':	'主要语言',
              'TRADUCCION':	'翻译',
              'PREVIEW':	'预览',
            },
            'ENCABEZADOS': {
              'PRACT':	'实践',
              'DESCR':	'描述',
              'STT1':	'陈述1',
              'STT2':	'陈述2',
              'LANG':	'语言',
            },
            'INPUTS': {
              'PRACT':	'输入实践内容',
              'DESCR':	'输入描述',
            }
          }
        },
        'ADICIONALES': {
          'STATUS': {
            'PEND':	'完成步骤',
            'DONE':	'此步骤已完成',
          },
          'TABS': {
            'QUESTIONS':	'其他问题',
            'TRANSLATE':	'翻译',
            'PREVIEW':	'预览',
          },
          'PREGUNTAS':{
            'STATUS': {
              'SIN':	'您尚未新增任何其他问题',
              'CON':	'问题已新增',
              'NOADICIONALES':	'您选择不新增其他问题',
              'CANCELNOADIC':	'您取消了不新增其他问题的选项',
              'ERROR':	'操作发生错误',
            },
            'ACCIONES': {
              'ADD':	'新增问题',
              'SIN':	'调研将不设有其他问题',
            },
            'WIZARD': {
              'NEW':	'新问题',
              'TIPOTITU':	'单击此处以配置其他问题',
              'TIPO': {
                'OPEN':	'开放式问题',
                'UNI':	'单选题',
                'MULT':	'多项选择题',
              },
              'FORM': {
                'TIPO':	'问题类型',
                'TOOLTIP': {
                  'REMOVE':	'删除此问题',
                },
                'MENSAJES': {
                  'BORRAR':	'您是否要删除此附加问题？',
                  'PREG_OK':	'问题已成功储存',
                  'PREG_ERR':	'储存问题时发生错误',
                  'PREG_MOD_OK':	'问题修改成功',
                  'PREG_MOD_ERR':	'修改问题时发生错误',
                  'OPC_OK':	'答案选项已成功保存',
                  'OPC_ERR':	'储存答案选项时发生错误',
                  'OPC_MOD_OK':	'答案选项修改成功',
                  'OPC_MOD_ERR':	'修改答案选项时发生错误',
                  'PREG_DEL_OK':	'问题已成功删除',
                  'PREG_DEL_ERR':	'删除问题时发生错误',
                  'OPC_DEL_OK':	'答案选项已成功删除',
                  'OPC_DEL_ERR':	'删除答案选项时发生错误',
                },
                'BOTONES':{
                  'SI':	'是',
                  'NO':	'否',
                }
              },
              'ABIERTA': {
                'TITULO':	'新开放式问题',
                'ACCION':	'输入问题内容',
                'ERROR':	'您尚未输入问题内容',
              },
              'MULTI':{
                'TITULOSING':	'新单选题',
                'TITULOMULT':	'新多选项问题',
                'ACCION':	'输入问题内容',
                'ERROR':	'您尚未输入问题内容',
                'MENSAJES': {
                  'BORRAR':	'您要删除此答案选项吗？',
                  'SINPREG':	'在输入问题内容前，您无法加入任何选项',
                  'SINANTE':	'您必须先输入上一个答案选项文本才能输入此答案选项文本',
                },
                'OPCIONES': {
                  'TITU':	'答案选项',
                  'INPUT': {
                    'TITU':	'答案选项',
                    'ERROR':	'您尚未输入答案选项内容',
                  }
                },
                'TOOLTIP': {
                  'ADD':	'添加答案选项',
                  'MOVE':	'移动答案选项',
                  'REMOVE':	'删除此答案选项',
                }
              }
            }
          },
          'TRADUCCIONES': {
            'TITULO':	'选择一种语言以开始输入翻译文本',
            'TITULOALTERNO':	'您没有在“语言”部分中选择任何其他语言',
            'NOTYET':	'翻译尚未完成',
            'MAIN':	'主要语言',
            'INPUT': {
              'NEW':	'输入问题翻译',
              'ERROR':	'尚未输入问题翻译！',
              'NEWOPC':	'输入答案选项翻译',
              'ERROROPC':	'您尚未输入答案选项翻译！',
            },
            'MENSAJES': {
              'PREG_OK':	'翻译内容储存成功',
              'PREG_ERR':	'储存翻译内容时发生错误',
              'PREG_MOD_OK':	'翻译内容已正确更新',
              'PREG_MOD_ERR':	'更新翻译内容时发生错误',
              'OPC_NOPREG':	'设置问题内容前，无法保存选项的翻译',
              'OPC_OK':	'翻译内容储存成功',
              'OPC_ERR':	'保存翻译内容时发生错误',
              'OPC_MOD_OK':	'翻译内容已成功更新',
              'OPC_MOD_ERR':	'更新翻译内容时发生错误',
            },
            'COMPLETE':	'翻译完成',
          },
          'PREVIEW': {
            'TITULO':	'选择语言以显示其他问题的翻译',
            'SINPREV':	'所选语言没有翻译内容',
            'LOADING':	'资料加载中',
            'INPUT': {
              'RESPABIERTA':	'填写答案',
              'ERRORABIERTA':	'您尚未填写答案！',
              'ELIGELANG':	'选择语言',
            }
          }
        },
        'COLABORADORES': {
          'SHEET':{
            'NUMBER':'工作表名称'
          },
          'STATUS': {
            'PEND':	'完成此步骤',
            'DONE':	'此步骤已完成',
            'LOCK': '重新打开通道',
          },
          'STATUSBAR': {
            // 'NOBD': 'No ha cargado la base de datos de colaboradores',
            // 'PROCES': 'La base de datos de colaboradores aún no ha sido almacenada',
            // 'ERROR': 'Se encontraron errores en el archivo',
            // 'OK': 'La base de datos de colaboradores está almacenada correctamente'
          },
          'CARD_BD': {
            // 'TITULO': 'Información',
            // 'NUMCOLABS': 'Número de colaboradores',
            // 'NUMCENTER': 'Number of work center',
            // 'FECHA': 'Fecha de carga',
            // 'ACCIONES': 'Acciones',
            // 'WANNADO': '¿Qué desea realizar?',
            'BOTONES': {
              // 'DESCARGA': 'Descargar la base de datos',
              // 'ELIMINA': 'Eliminar la base de datos'
            }
          },
          'CARD_NOBD': {
            // 'TITULO': 'Siga estos pasos para cargar la información de sus colaboradores a CulturalGO',
            'PASOS': {
              // '1': 'Descargue la plantilla de base de datos de colaboradores',
              // '2': 'Llene la plantilla con la información de sus colaboradores, con base en las columnas proporcionadas',
              // '3': 'Cargue el archivo con la información de sus colaboradores'
            },
            // 'TOOLTIP': 'Este archivo cuenta con macros de validación de datos'
          },
          'CARD_NOERR': {
            // 'TITULO': 'Información',
            // 'NUMCOLABS': 'Número de colaboradores en el archivo',
            // 'NUMCT': 'Number of work cnter in the loaded file',
            // 'FILENAME': 'Nombre del archivo',
            // 'GUARDAR': '¿Desea almacenar esta información?',
            'BOTONES': {
              // 'SI': 'Si',
              // 'NO': 'No'
            }
          },
          'CARD_ERRFND': {
            // 'TITULO': 'Información',
            // 'ROWS_OK': 'Número de filas correctas',
            // 'ROWS_NOTOK': 'Número de filas con errores',
            // 'MOREINFO': '* Mas abajo se muestra a detalle la lista de errores',
            // 'FILENAME': 'Nombre del archivo',
            // 'GUARDAR': 'La información cargada no puede ser almacenada',
            // 'DELETE': 'Borrar archivo'
          },
          'CARD_ERRLIST': {
            'TITULO': {
              // '1': 'Filas con errores: ',
              // '2': 'Errores totales encontrados: '
            },
            'INFO': {
              // 'ROW': 'Fila ',
              // 'ERRNUM': 'Número de errores: ',
              // 'SHOW': 'Haga clic aquí para ver los errores de esta fila'
            },
            'DETALLE': {
              // 'TIPO': 'Tipo de error',
              // 'DESCR': 'Descripción',
              // 'COLUMNA': 'Columna',
              // 'DATO': 'Dato erróneo'
            },
            'ERRORES': {
              // 'alfabetica': 'Invalidez alfabética',
              // 'alfanumerica': 'Invalidez alfanumérica',
              // 'numerica': 'Invalidez numérica',
              // 'email': 'Invalidez de correo electrónico',
              // 'vacio': 'Celda vacía',
              // 'columna': 'Columna desconocida',
              'CT': '找不到工作中心'
            },
            'DESCRIPCION': {
              // 'alfabetica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres alfabéticos (A - Z) y los siguientes caracteres especiales: ( ) . , : - ',
              // 'alfanumerica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres alfabéticos (A - Z), numéricos (0 - 9) y los siguientes caracteres especiales: ( ) . , : - ',
              // 'numerica': 'La información contiene uno o más caracteres no permitidos. Sólo se permiten caracteres numéricos (0 - 9)',
              // 'email': 'La información no cuenta con la sintáxis correcta ( correo@dominio.com )',
              // 'vacio': 'La celda carece de información. Esta columna es obligatoria.',
              // 'columna': 'La columna no pertenece a la plantilla proporcionada por CulturalGO',
              'CT': '在可用的工作中心列表中找不到此行中的指定工作中心'
            }
          },
          'CARD_LOAD': {
            'CARGA': {
              // 'TITULO': 'Cargando',
              // 'INFO': 'Analizando la información del archivo, espere un momento'
            },
            'GUARDA': {
              // 'TITULO': 'Guardando',
              // 'INFO': 'Almacenando la información en el sistema, permanezca en esta pantalla hasta que el proceso finalice'
            },
          },
          'MENSAJES': {
            // 'GUARDA_1': '¿Confirma almacenar la información de ',
            // 'GUARDA_2': ' colaboradores?',
            // 'GUARDADO': 'La base de datos de colaboradores se almacenó correctamente',
            // 'GUA_ERR': 'Ocurrió un error al almacenar la información. Intente nuevamente mas tarde',
            // 'DELETE_1': '¿Confirma eliminar la información de ',
            // 'DELETE_2': ' colaboradores?',
            // 'DEL_OK_1': 'se eliminaron correctamente ',
            // 'DEL_OK_2': ' colaboradores',
            // 'DEL_ERR': 'Ocurrió un error al eliminar la base de datos de colaboradores. Intente nuevamente mas tarde',
            // 'DELFILE': 'La base de datos cargada se removió correctamente',
            // 'EXCEL': 'Generando archivo de excel, por favor espere un momento',
            // 'EXTMAL': 'El archivo seleccionado no tiene la extensión correcta. Sólo se permite la carga del archivo proporcionado por CulturalGO',
            // 'NOROWS': 'El archivo seleccionado no cuenta con ningún registro',
            // 'VACIO': 'El archivo seleccionado está vacío, o la información no se encuentra en la primera hoja',
            'BOTONES': {
              // 'SI': 'Si',
              // 'NO': 'No'
            }
          },
          'EXCELINFO': {
            // 'HOJA': 'Datos de colaboradores',
            // 'TITULO': 'Base de datos de colaboradores',
            // 'AUTOR': 'CulturalGO',
            // 'ASUNTO': 'Descargado de la plataforma'
          },
          'UPLOAD':	'单击此处浏览员工数据库',
          'REMOVE':	'从上传中删除',
          'SEND':	'发送到数据库',
          'PROCESO': {
            'STP1':	'分析员工数据库',
            'STP2':	'保存员工数据库',
          }
        }
      }
    }
};
